import { ADMIN_CONTACT_CITY, ADMIN_CONTACT_CITY_ROLES_OPTIONS } from '../../../constants/admin.contacts.constants';
import { INPUT_STATES } from '../../forms/forms.utils';
import SelectField from '../../forms/SelectField';
import TextField from '../../forms/TextField';

const AdminContactCityFields = ({ parentElement, data, canUpdate, isSubmitting, inputName, onEnter, onInput }) => {
  if (data?.type !== ADMIN_CONTACT_CITY) {
    return null;
  }

  return (
    <>
      <TextField
        label="Gebruikersnaam"
        name={inputName}
        required
        value={data?.userName}
        state={INPUT_STATES.DEFAULT}
        onKeyDown={onEnter}
        onChange={(value) => onInput(value, 'userName')}
        disabled={isSubmitting}
        readOnly={!canUpdate}
      />
      <TextField
        label="Functie"
        name={'function'}
        value={data.function}
        state={INPUT_STATES.DEFAULT}
        onKeyDown={onEnter}
        onChange={(value) => onInput(value, 'function')}
        disabled={isSubmitting}
        readOnly={!canUpdate}
      />
      {!!data?.type && (
        <SelectField
          id="add-contact-modal-role"
          label="Rechten"
          name={'role'}
          required
          // onChange={(value) => onInput(value, 'role')}
          disableSearch={true}
          options={ADMIN_CONTACT_CITY_ROLES_OPTIONS}
          parentElement={parentElement}
          value={data.role}
          readOnly={true}
          className="u-margin-top"
          disabled={isSubmitting}
        />
      )}
    </>
  );
};

export default AdminContactCityFields;
